import { SxProps, Theme } from '@mui/material';

const documentUploadStyles = {
  dialogContent: {
    padding: 0,
  },
  dialogTitle: {
    alignItems: 'center',
    color: 'primary.main',
    display: 'flex',
    fontWeight: 600,
    justifyContent: 'space-between',
  },
  closeButton: {
    color: 'common.gray',
  },
  avatar: {
    border: '1px solid',
    borderColor: 'common.border',
    height: 100,
    width: 100,
  },
  avatarImage: {
    style: {
      objectFit: 'contain',
    },
  },
  documentIcon: {
    alignItems: 'center',
    display: 'flex',
    height: 100,
    justifyContent: 'center',
    width: 100,
  },
  statusContainer: {
    alignItems: 'center',
    display: 'flex',
    minHeight: 24,
    padding: '0 20px 16px',
  },
  uploadError: {
    color: 'common.error',
    fontSize: 12,
  },
} satisfies Record<string, SxProps<Theme>>;

export default documentUploadStyles;
